import { Behavior } from './Behavior';
import { ContentType, LessonMode, PartialScoringType, QuestionFeedbackState } from '../../Constants';
import UtilsService from '../services/UtilsService';
import { confirmDialog } from '../components/dialogs';
import questionFeedbackManager from '../managers/QuestionFeedbackManager';

export class ImageHotSpotBehavior extends Behavior {
  checkForValidResponse = (responseAnswer) => {
    if (responseAnswer && responseAnswer.prompts) {
      const prompt = responseAnswer.prompts.find((element) => element.text === 'selected');
      if (typeof prompt !== 'undefined') {
        return true;
      }
    }
    return false;
  }

  isAutoScored = (model) => {
    const autoScore = (ContentType.getAutoscore(model.type) &&
      !model.survey && !model.unscored);

    return autoScore;
  }

  setResponseData = async (prompt, responseAnswer, model) => {
    const savedPrompt = responseAnswer.prompts.find((element) => element.id === prompt.id);
    if (savedPrompt.text === 'selected') {
      savedPrompt.text = 'unselected';
    } else {
      if (model.correctAnswerCount <= 1) {
        savedPrompt.text = 'selected';
        responseAnswer.prompts.forEach((element) => {
          if (element.id !== prompt.id) {
            element.text = 'unselected';
          }
        });
      } else if (model.allowSelectAll) {
        savedPrompt.text = 'selected';
      } else {
        const currentSelected = responseAnswer.prompts.filter((element) => element.text === 'selected');
        const selectedCount = (currentSelected) ? currentSelected.length : 0;

        if ((model.correctAnswerCount <= selectedCount && !model.unscored)) {
          await confirmDialog({
            title: `${UtilsService.maxSelected()}`,
            text: `${UtilsService.deselect()}`,
            showCancelButton: false,
            confirmButtonText: `${UtilsService.confirmOk()}`
          });
        } else {
          savedPrompt.text = 'selected';
        }
      }
    }
  }

  getInitializedResponse = (lessonElementId, model) => {
    const prompts = [];
    model.prompts.forEach((prompt, index) => {
      const newPropmt = {
        id: prompt.id,
        text: 'unselected'
      };
      prompts.push(newPropmt);
    });
    const responseAnswer = {
      prompts,
      lessonElementId,
      selectedIncorrectList: [],
      omittedList: [],
      trueCorrectList: []
    };
    return responseAnswer;
  }

  getCorrectAnswersText = (model) => {
    if (!model ||
      !model.prompts ||
      !model.validation ||
      !model.validation.prompts) {
      return '<div></div>';
    }

    let text = '';
    let count = 1;
    model.validation.prompts.forEach((prompt) => {
      const renderPrompt = model.prompts.find((element) => element.id === prompt.id);
      let displayLabel = null;

      if (renderPrompt) {
        displayLabel = renderPrompt.displayLabel;
      }

      const resultLabel = (prompt.correctAnswers) ? prompt.correctAnswers[0] : 'unselected';
      const label = (!UtilsService.isNullOrEmpty(displayLabel)) ? `${displayLabel} ${resultLabel}` : resultLabel;

      text += '<div class=\'answer-list-row\'>';
      text = `${text }<div class='list-number'>${count}</div>`;
      text += '<div class=\'correct-icon\'>';
      text += '</div><div class=\'answer-text\'>';
      text = `${text + label}</div>`;
      text += '</div>';
      ++count;
    });
    return text;
  }

  setCorrectAnswer = (state, model) => {
    const tempPrompts = [];
    state.currentResponseAnswer.prompts.forEach((prompt) => {
      const validPrompt = model.validation.prompts.find((element) => element.id === prompt.id);
      if (validPrompt) {
        if (validPrompt.correctAnswers && validPrompt.correctAnswers.length > 0) {
          tempPrompts.push({
            text: validPrompt.correctAnswers[0],
            id: validPrompt.id
          });
        }
      }
    });
    const temp = {
      prompts: tempPrompts,
      lessonElementId: model.lessonElementId,
      selectedIncorrectList: [],
      omittedList: [],
      trueCorrectList: []
    };

    state.setCurrentResponse(UtilsService.safeMobxClone(temp));
  }

  resetStudentAnswer = (state) => {
    const cached = UtilsService.safeMobxClone(state.cachedResponseAnswer);
    state.setCurrentResponse(cached);
  }

  /// ///
  // model = content model
  //
  getQuestionFeedbackText = (model, correctFeedback, incorrectFeedback, correctFeedbackBody, incorrectFeedbackBody, mode, questionIsCorrect, currentAttemptCount, { lessonElementState }) => {
    let numberOmitted = 0;
    let numberSelectedIncorrect = 0;
    let correctCount = 0;
    if (lessonElementState && lessonElementState.currentResponseAnswer) {
      numberOmitted = (lessonElementState.currentResponseAnswer.omittedList) ? lessonElementState.currentResponseAnswer.omittedList.length : 0;
      numberSelectedIncorrect = (lessonElementState.currentResponseAnswer.selectedIncorrectList) ? lessonElementState.currentResponseAnswer.selectedIncorrectList.length : 0;
      correctCount = (lessonElementState.currentResponseAnswer.trueCorrectList) ? lessonElementState.currentResponseAnswer.trueCorrectList.length : 0;
    }

    let textBody = '';
    if (mode === LessonMode.PREVIEW || mode === LessonMode.ITEM_PREVIEW || mode === LessonMode.STUDENT_PREVIEW || mode === LessonMode.PUBLISHER_PREVIEW) {
      textBody += UtilsService.previewWarning();
    } else {
      if (typeof currentAttemptCount !== 'undefined' && currentAttemptCount !== -1 && currentAttemptCount > 1) {
        textBody += UtilsService.saveWarning();
      } else {
        textBody += UtilsService.saveCommit();
      }
    }

    let textHeader = '';
    let attemptsText = '';
    
    // Add attempts remaining text for practice mode when answer is incorrect or partially correct
    if (questionFeedbackManager.isPractice && 
        (questionIsCorrect === QuestionFeedbackState.INCORRECT || questionIsCorrect === QuestionFeedbackState.PARTIAL_CORRECT) &&
        model.lessonElementId) {
      attemptsText = questionFeedbackManager.getAttemptsRemainingText(model.lessonElementId);
    }

    const showPartialMessage = (questionIsCorrect === QuestionFeedbackState.PARTIAL_CORRECT) || (questionIsCorrect === QuestionFeedbackState.INCORRECT);
    if (questionIsCorrect === QuestionFeedbackState.CORRECT) {
      textHeader = correctFeedback;
      if (correctFeedbackBody) {
        textBody = `${correctFeedbackBody} ${textBody}`;
      }
    } else if ((showPartialMessage) && (model.correctAnswerCount > 1) && (correctCount > 0)) {
      textHeader = `${UtilsService.partiallyCorrect()}`;
      let custom = '';
      if (incorrectFeedbackBody) {
        custom = `${incorrectFeedbackBody }<br/>`;
      }
      if (numberOmitted > 0 && numberSelectedIncorrect === 0) {
        textBody = `${UtilsService.partiallyCorrectSelectPrompt()}.<br/>${ custom }${textBody}`;
      } else {
        textBody = `${UtilsService.partiallyCorrectSelectPrompt2()}.<br/>${ custom }${textBody}`;
      }
    } else {
      textHeader = incorrectFeedback;
      if (incorrectFeedbackBody) {
        textBody = `${incorrectFeedbackBody}<br/> ${textBody}`;
      }
    }

    // Add attempts text after the header if it exists
    if (attemptsText) {
      textHeader += attemptsText;
    }

    let finalText = '<div class=\'question-feedback-header\'>';
    finalText += textHeader;
    finalText += '</div>';
    finalText += '<div class=\'question-feedback-body\'>';
    finalText += textBody;
    finalText += '</div>';

    return finalText;
  }

  isAnswerCorrect = (answerId, lessonElementState, model, isPracticeRunning) => {
    if (!model ||
      !model.validation ||
      !model.prompts ||
      !model.validation.prompts ||
      !lessonElementState ||
      !lessonElementState.currentResponseAnswer ||
      !lessonElementState.currentResponseAnswer.prompts) {
      return null;
    }
    const response = lessonElementState.currentResponseAnswer;
    const answer = lessonElementState.currentResponseAnswer.prompts.find((element) => element.id === answerId);
    // TODO unused // const validationPrompt = model.validation.prompts.find(element => element.id === answerId);
    const selected = answer.text === 'selected';
    const notSelected = answer.text === 'unselected';
    if (isPracticeRunning) {
      if (answer && response.selectedIncorrectList && response.omittedList && response.trueCorrectList) {
        if (selected && response.selectedIncorrectList.indexOf(answer.id) > -1) {
          return false;
        }
        if (notSelected && response.omittedList.indexOf(answer.id) > -1) {
          return null;
        }
        if (selected && response.trueCorrectList.indexOf(answer.id) > -1) {
          return true;
        }
      }
    } else {
      const prompts = model.validation?.prompts;
      const prompt = prompts.find((element) => element.id === answerId);
      const correctAnswer = (prompt.correctAnswers) ? prompt.correctAnswers[0] : '';

      if (correctAnswer && answer && correctAnswer === 'selected' && answer.text === 'selected') {
        return true;
      } else if (correctAnswer && answer && correctAnswer === 'unselected' && answer.text === 'unselected') {
        return null;
      } else if (correctAnswer && answer && correctAnswer === 'unselected' && answer.text === 'selected') {
        return false;
      } else if (correctAnswer && answer && correctAnswer === 'selected' && answer.text === 'unselected') {
        return false;
      }
    }
    return null;
  }

  isQuestionCorrect = (lessonElementState, lessonElementId) => {
    let questionCorrect = QuestionFeedbackState.INCORRECT;

    if (!lessonElementState) {
      questionCorrect = QuestionFeedbackState.INCORRECT;
      return QuestionFeedbackState.INCORRECT;
    }

    if (lessonElementState.submittedItemScore >= lessonElementState.maxScore) {
      questionCorrect = QuestionFeedbackState.CORRECT;
    }
    if ((lessonElementState.submittedItemScore > 0) && (lessonElementState.submittedItemScore < lessonElementState.maxScore)) {
      questionCorrect = QuestionFeedbackState.PARTIAL_CORRECT;
    }

    let correctCount = 0;
    if (lessonElementState && lessonElementState.currentResponseAnswer) {
      correctCount = (lessonElementState.currentResponseAnswer.trueCorrectList) ? lessonElementState.currentResponseAnswer.trueCorrectList.length : 0;
    }

    if (questionCorrect === QuestionFeedbackState.PARTIAL_CORRECT && (correctCount <= 0)) {
      questionCorrect = QuestionFeedbackState.INCORRECT;
    }
    return questionCorrect;
  }
}

export default new ImageHotSpotBehavior();
